<template>
  <Multiselect
    v-model="context.model"
    v-bind="context.attributes"
    :options="optionKeys"
    :custom-label="getLabel"
    :searchable="false"
    :class="{ 'multiselect--inline-dropdown': inlineDropdown }"
    :max-height="4.5 * 45"
    :option-height="45"
  >
    <template #selection="{values}">
      <span v-if="values.length === 1">{{ getLabel(values[0]) }}</span>
      <span v-if="values.length > 1">{{ values.length }} ausgewählt</span>
    </template>
    <template #option="{option}">
      <div v-if="context.attributes.multiple" class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          value=""
          :checked="isSelected(option)"
        />
        <label class="form-check-label">
          {{ getLabel(option) }}
        </label>
      </div>
    </template>
    <template #caret="{toggle}">
      <div
        class="multiselect__select form-select"
        @mousedown.prevent="toggle()"
      />
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { find, isObject, isArray } from 'lodash-es';

export default {
  components: {
    Multiselect,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
    inlineDropdown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    optionKeys() {
      return this.context.options.map((option) => option.value);
    },
  },
  methods: {
    getLabel(optionKey) {
      return find(this.context.options, { value: optionKey }).label;
    },
    isSelected(option) {
      let selectedOptions = [];

      if (isArray(this.context.model)) {
        selectedOptions = this.context.model;
      } else if (isObject(this.context.model)) {
        selectedOptions = [this.context.model];
      }

      return selectedOptions.includes(option);
    },
  },
};
</script>

<style lang="scss">
@use '~tokens/sass/utils';
@use "sass:map";

.multiselect {
  position: relative;

  &:focus {
    outline: none;
  }
}

.multiselect__select {
  position: absolute;
  z-index: 2;
  inset: 0;
  cursor: pointer;
  height: utils.f-convert-to-rem(44);
  background-color: transparent;
}

.multiselect--active .multiselect__select {
  border-color: utils.$bs-input-focus-border-color;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.multiselect__tags {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  height: utils.f-convert-to-rem(44);
  padding-left: utils.$bs-input-padding-x;
}

// Dropdown element
.multiselect__content-wrapper {
  position: absolute;
  z-index: 5;
  right: 0;
  left: 0;
  top: 100%;
  margin-top: -1px;
  border: 1px solid utils.$bs-input-focus-border-color;
  border-radius: 0 0 utils.$bs-input-border-radius utils.$bs-input-border-radius;
  background-color: #fff;
  box-shadow: 0 8px 14px 0 rgb(0 0 0 / 14%);
  font-size: 1rem;
  line-height: 1.125em;
  overflow-y: scroll;

  * {
    cursor: pointer !important;
  }
}

.multiselect--inline-dropdown .multiselect__content-wrapper {
  position: relative;
}

// Options list
.multiselect__content {
  @include utils.bs-list-unstyled;
  // stylelint-disable-next-line declaration-no-important
  display: block !important;
  margin-bottom: 0;
}

// Single option element
.multiselect__option {
  display: block;
  padding: 0.75rem;
  border-bottom: 1px solid rgba(208, 215, 221, 0.33);

  @at-root #{&}--selected {
    font-weight: 500;
  }

  @at-root {
    &:hover,
    #{&}--highlight {
      background-color: map.get(utils.$bs-theme-colors, 'secondary');
      border-color: map.get(utils.$bs-theme-colors, 'secondary');
    }
  }
}
</style>
